import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["title", "titleId"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { createElement } from 'react';
import { CreateSVG } from "../lib/index.js";
function SvgIconWifi(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/createElement(CreateSVG, _objectSpread(_objectSpread({}, props), {}, {
    renderIcon: function renderIcon(props) {
      return /*#__PURE__*/React.createElement("svg", _extends({
        id: "Icon-wifi_svg__filled",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 52 52",
        "aria-labelledby": titleId
      }, props), title ? /*#__PURE__*/React.createElement("title", {
        id: titleId
      }, title) : null, /*#__PURE__*/React.createElement("circle", {
        cx: 26,
        cy: 39,
        r: 4
      }), /*#__PURE__*/React.createElement("path", {
        d: "M26,25a13.3672,13.3672,0,0,0-11.7314,6.999,2,2,0,1,0,3.4628,2.002,9.3361,9.3361,0,0,1,16.5372,0,2,2,0,1,0,3.4628-2.002A13.3672,13.3672,0,0,0,26,25Z"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M26,17A22.5125,22.5125,0,0,0,7.36,26.8555a2,2,0,1,0,3.28,2.289A18.563,18.563,0,0,1,26,21a19.261,19.261,0,0,1,15.3818,8.1758,2,2,0,0,0,3.2364-2.3516A23.2713,23.2713,0,0,0,26,17Z"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M26,9A31.6756,31.6756,0,0,0,1.4531,20.7324a2,2,0,0,0,3.0938,2.5352,27.5458,27.5458,0,0,1,42.9062,0,2,2,0,0,0,3.0938-2.5352A31.6756,31.6756,0,0,0,26,9Z"
      }));
    }
  }));
}
export default SvgIconWifi;